(function () {
    let infiniteObserver;
  
    function findNextPage(container, html) {
      const nextPagination = html.querySelector('[data-skim1-collection-pagination]');
      if (nextPagination) {
        const currentPagination = container.querySelector('[data-skim1-collection-pagination]');
        if (currentPagination) {
          currentPagination.replaceWith(nextPagination);
        }
        watchInfinite(container);
        return;
      }
  
      const currentPagination = container.querySelector('[data-skim1-collection-pagination]');
      if (currentPagination) currentPagination.remove();
    }
  
    function appendProducts(button) {
      const container = button.closest('[data-skim1-collection]');
      const grid = container && container.querySelector('[data-skim1-collection-grid]');
      if (!container || !grid || button.getAttribute('aria-busy') === 'true') return;
  
      button.setAttribute('aria-busy', 'true');
  
      fetch(button.href, { credentials: 'same-origin' })
        .then((response) => response.text())
        .then((text) => {
          const html = new DOMParser().parseFromString(text, 'text/html');
          const nextGrid = html.querySelector('[data-skim1-collection-grid]');
          if (!nextGrid) {
            window.location.href = button.href;
            return;
          }
  
          nextGrid.querySelectorAll(':scope > .grid__item').forEach((item) => {
            grid.appendChild(item);
          });
  
          findNextPage(container, html);
  
          if (typeof initializeScrollAnimationTrigger === 'function') {
            initializeScrollAnimationTrigger(container);
          }
        })
        .catch(() => {
          window.location.href = button.href;
        })
        .finally(() => {
          button.removeAttribute('aria-busy');
        });
    }
  
    function watchInfinite(scope) {
      if (!('IntersectionObserver' in window)) return;
  
      if (!infiniteObserver) {
        infiniteObserver = new IntersectionObserver(
          (entries) => {
            entries.forEach((entry) => {
              if (!entry.isIntersecting) return;
              const button = entry.target;
              infiniteObserver.unobserve(button);
              appendProducts(button);
            });
          },
          { rootMargin: '480px 0px' }
        );
      }
  
      scope.querySelectorAll('[data-skim1-collection-infinite]:not([data-skim1-infinite-ready])').forEach((button) => {
        button.setAttribute('data-skim1-infinite-ready', 'true');
        infiniteObserver.observe(button);
      });
    }
  
    document.addEventListener('click', (event) => {
      const button = event.target.closest('[data-skim1-collection-load-more]');
      if (!button) return;
  
      event.preventDefault();
      appendProducts(button);
    });
  
    document.addEventListener('DOMContentLoaded', () => watchInfinite(document));
    document.addEventListener('shopify:section:load', (event) => watchInfinite(event.target));
  })();
  